export default __webpack_public_path__ + "static/calidad-de-la-investigacion-large-e4eeb424ba8b48c72ed8e657a678afd6.svg";